var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-not-found"},[_c('p',{staticClass:"not-found-header"},[_vm._v("404")]),_c('p',{staticClass:"not-found-subheader"},[_vm._v(_vm._s(_vm.$t('text.page_not_found')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }